import React, { useState } from "react";
import styles from './QuestionsItem.module.scss'
import { Arrow } from "../Arrow";

import cn from 'classnames'

export const QuestionsItem = ({ title, description }) => {
	const [show, setShow] = useState(true)
	
	return (
		<div>
			<div className={cn(styles.questions, !show ? styles.questions_show : '')}>
				<div onClick={() => setShow(!show)} className={styles.questions_title}>
					<span>{title}</span>
					<div className={cn(styles.plus, show ? '' : styles.plus_rotate)} />
				</div>
			</div>
			<div className={cn(styles.questions_description, show ? styles.questions_description_show : '')}>
				{description}
			</div>
		</div>
	)
}
